var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParticipantPending = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  fill: "none",
  viewBox: "0 0 44 44"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 17.5,
  stroke: "#F7F7FA",
  strokeDasharray: "4 4"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 12v6h.01l-.01.01L20 22l-4 4 .01.01H16V32h12v-5.99h-.01L28 26l-4-4 4-3.99-.01-.01H28v-6zm10 14.5V30h-8v-3.5l4-4zm-4-5-4-4V14h8v3.5z"
})));
export default SvgParticipantPending;